import {
	Component,
	computed,
	effect,
	inject,
	input,
	InputSignal,
	model,
	ModelSignal,
	output,
	OutputEmitterRef,
	signal,
	Signal,
	untracked,
	WritableSignal
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { IRComplianceResultComponent } from '../ir-compliance-result/ir-compliance-result.component';
import { IPhotoReportComplianceResult } from '../../../control/models/photoReport';
import { INewChatMessage } from '../../models/chat';
import { MatTooltip } from '@angular/material/tooltip';
import { ChatService } from '../../services/chat.service';
import { ImageRecognitionService } from '../../services/image-recognition.service';

@Component({
	selector: 'app-ir-compliance-widget',
	imports: [PhIconWrapperComponent, TranslateModule, IRComplianceResultComponent, MatTooltip],
	templateUrl: './ir-compliance-widget.component.html',
	styleUrl: './ir-compliance-widget.component.scss'
})
export class IRComplianceWidgetComponent {

	private readonly chatService: ChatService = inject(ChatService);
	private readonly imageRecognitionService: ImageRecognitionService = inject(ImageRecognitionService);

	complianceResult: InputSignal<IPhotoReportComplianceResult> = input.required();
	planogramId: InputSignal<number> = input.required();
	photoreportId: InputSignal<number> = input.required();
	executionBlockShown: InputSignal<boolean> = input<boolean>(false);
	opened: ModelSignal<boolean> = model(false);
	smallMode: InputSignal<boolean> = input(false);

	onReturn: OutputEmitterRef<INewChatMessage> = output<INewChatMessage>();
	onConfirm: OutputEmitterRef<INewChatMessage> = output<INewChatMessage>();
	onGoToChat: OutputEmitterRef<number> = output<number>();

	readonly seen: WritableSignal<boolean> = signal(false);

	readonly widgetShown: Signal<boolean> = computed(() => !!this.complianceResult());

	constructor() {
		effect(() => {
			this.seen.set(!!this.complianceResult()?.seen);
		});

		effect(() => {
			if (!this.opened() || this.seen()) return;
			untracked(() => this.markAsViewed());
		});
	}

	toggleOverlay(): void {
		this.opened.update((opened: boolean) => !opened);
		this.chatService.tempMessage = { message: '', files: [] };
	}

	closeOverlay(): void {
		this.opened.set(false);
	}

	private markAsViewed(): void {
		const result: IPhotoReportComplianceResult = this.complianceResult();
		this.seen.set(true);
		result.seen = true;
		this.imageRecognitionService.markComplianceSeen(this.photoreportId()).subscribe();
	}
}
